import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplatePreviewComponent } from './template-preview.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [TemplatePreviewComponent],
  imports: [
    CommonModule,
    FormsModule
    
  ],exports:[
    TemplatePreviewComponent
  ]
})
export class TemplatePreviewModule { }
